const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/** 무물라이브 콘텐츠 게시 시각을 상대 시간 문구로 변환한다. (예: `3일 전`) */
export const formatPostedAt = (postedAt: string, now = Date.now()) => {
  const elapsed = now - new Date(postedAt).getTime();

  if (Number.isNaN(elapsed) || elapsed < MINUTE) return '방금 전';
  if (elapsed < HOUR) return `${Math.floor(elapsed / MINUTE)}분 전`;
  if (elapsed < DAY) return `${Math.floor(elapsed / HOUR)}시간 전`;

  return `${Math.floor(elapsed / DAY)}일 전`;
};
